import Vue from "vue";

let config = Vue.observable({
  gtagId: "",
  locale: process.env.VUE_APP_LOCALE || "en-US",
  disableAdult: true,
  disableCreatorsOnlyPage: [""],
  maxUploadFileBytesSize: 2000000000,
  apiUrl: process.env.VUE_APP_API_URL || "/graphql",
  backendUrl: process.env.VUE_APP_BACKEND_URL || "/api",
  s3Url: process.env.VUE_APP_S3_URL || "/files",
  s3UploadUrl: process.env.VUE_APP_S3_UPLOAD_URL || "/files",
  publicS3Url: process.env.VUE_APP_PUBLIC_S3_URL || "/public-files",
  thumbnailUrl: process.env.VUE_APP_THUMBNAIL_URL || "/image-thumbnails",
  videoThumbnailUrl: process.env.VUE_APP_VIDEOTHUMBNAIL_URL || "/video-thumbnails",
  supportEmail: "",
  supportUserId: "1",
  facebookAppId: "519046602188218",
  // TODO: default url should be production url.
  twitterCallbackUrl:
    process.env.VUE_APP_TWITTER_CALLBACK_URL ||
    (typeof window !== "undefined" &&
      `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? ":" + window.location.port : ""
      }/login/twitter`) ||
    "",
  sentryKey: process.env.VUE_APP_SENTRY_DSN || "",
  fileTypes: {
    image: [
      "jpg",
      "jpeg",
      "jpe",
      "heif",
      "heic",
      "png",
      "webp",
      "jxr",
      "jif",
      "jfif",
      "jfi",
      "jp2",
      "j2k",
      "jpf",
      "jpx",
      "jpm",
    ],
    video: ["webm", "mkv", "mov", "qt", "wmv", "mp4", "m4v", "mpg", "mpeg", "mpv", "avi"],
    audio: ["mp3", "aac", "ogg", "m4a"],
    document: ["pdf"],
  },
  userRegistrationRole: "member",
  questionaryHiddenField: [],
  companyName: "Academtech LLC",
  companyAddress: "690 S Highway 89, Suite 200, 83001, Jackson, Wyoming, USA",
  moneyUseGrouping: false,
  auth: {
    facebook: false,
    twitter: false,
  },
  attachments: {
    MAX_AUCTION_COVER_FILES: 3,
    MAX_COVER_FILES: 1,
    MAX_FILES_UPLOAD_FOR_CREATOR: 10,
    MAX_FILES_UPLOAD_FOR_MEMBER: 1,
  },
  // if true then allow signup by phone instead of email
  featurePhoneSignUp: false,
  // if true then allow go live
  featureGoLive: true,
  // if true then allow react on posts
  featureFeedReaction: true,
  // if true then allow view online users status
  featureUserOnlineStatus: true,
  // if true then allow paid message options on site
  featurePaidSentMessage: true,
  // if true then allow tipping in messages
  featureTipping: true,
  // if true then allow callings on site
  featureCalling: true,
  // if true then allow create new even type posts.
  featureEvents: false,
  // if true then restricts publish feature for 'member' role, hides social network links, location and tags, its edit
  featureRestrictMember: true,
  // if true, there are themes on the site
  featureTags: true,
  // if has name of field, it will be required
  featurePayeeInfoRequiredFields: ["id_photo", "photo_with_id"],
  // Define allowed file types for posts, except those do not defined in fileTypes.
  postAllowedFileTypes: ["image", "video", "audio", "document"],
  // if true creator can use links to different resources
  featureClickableUserLinks: true,
  siteName: "connect",
  // if true will enabled to use Refill Balance Button in Balance History
  get featureBalanceRefill() {
    return this.featureCalling || this.featurePaidSentMessage;
  },
  soloCreatorId: null as null | string,
  webPushNotificationsPublicKey: "",
  featureScheduledMassMessage: false,
  // if true, a creator is able to request a payout
  featurePayoutRequest: true,
  // if true, will enable recording audio messages
  featureAudioMessageAttachments: true,
  // if true, will enable recording audio messages
  featureAutoMassMessages: true,
  // if true creator can add photo galleries
  featurePhotoGalleries: true,
  // if true AI messaging can be turned on for creators
  featureAI: false,
});

export function setConfig(override: Partial<typeof config>) {
  for (const key in override) {
    Vue.set(config, key, override[key as keyof typeof override]);
  }
}

export default config;
